import React from "react";
import GlobalDialog from "../mui/Dialogue/GlobalDialog";
import { IconButton, Stack, Typography, CircularProgress, Box } from "@mui/material";
import { Icon } from "@iconify/react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { generateClassLink, clearLmsLink } from "../../redux/features/lmsSlice";

function LinkRow({ label, value }) {
    const { enqueueSnackbar } = useSnackbar();
    return (
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
            <Box sx={{ minWidth: 90 }}>
                <Typography variant="body2" color="text.secondary">{label}</Typography>
            </Box>
            <Typography variant="body2" sx={{ wordBreak: "break-all", flexGrow: 1 }}>{value}</Typography>
            <CopyToClipboard
                text={value}
                onCopy={() => enqueueSnackbar("Copied", { variant: "success" })}
            >
                <IconButton size="small">
                    <Icon icon="bx:copy-alt" width="20" height="20" color="#2f72b3" />
                </IconButton>
            </CopyToClipboard>
        </Stack>
    );
}

/** Generates a fresh Interval LMS class for the logged-in employee (step 1 of the employee-portal
 *  integration): a student link anyone can join with, and a host link that signs THIS employee in as
 *  host automatically — no separate LMS account. Mimics RescheduleSessionPopup's MenuItem-popup shape. */
export const GenerateClassLink = ({ handleClose, title }) => {
    const [open, setOpen] = React.useState(false);
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { loading, lastLink, error } = useSelector((state) => state.lms);

    const handleOpen = () => {
        dispatch(clearLmsLink());
        setOpen(true);
        dispatch(generateClassLink({ title })).then((res) => {
            if (res.payload?.status !== "success") {
                enqueueSnackbar(res.payload?.message || "Could not generate the class link", { variant: "error" });
            }
        });
    };

    return (
        <div>
            <GlobalDialog
                setOpen={setOpen}
                open={open}
                fullWidth
                maxWidth={"sm"}
                closeButton={true}
                title="Class link"
                popupButton={
                    <IconButton
                        aria-label="generate-class-link"
                        size="small"
                        id="basic-button"
                        onClick={handleOpen}
                    >
                        <Icon icon="mdi:video-plus-outline" width="22" height="22" color="#2f72b3" />
                        Generate class link
                    </IconButton>
                }
                content={
                    loading ? (
                        <Stack alignItems="center" sx={{ py: 3 }}>
                            <CircularProgress size={28} />
                        </Stack>
                    ) : error ? (
                        <Typography color="error">{error}</Typography>
                    ) : lastLink ? (
                        <Box sx={{ pt: 1 }}>
                            <LinkRow label="You (host)" value={lastLink.hostLink} />
                            <LinkRow label="Student" value={lastLink.studentLink} />
                        </Box>
                    ) : null
                }
            />
        </div>
    );
};
